import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { IconProps } from "./types";

export function CheckIcon({ size, ...props }: IconProps) {
    return <CheckRoundedIcon fontSize={size} {...props} />;
}
